/* eslint-disable global-require */
import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { Col, Row, Image, Container, Button, Modal, Badge, Alert } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faCodeBranch, faSearch, faExclamationTriangle } from "@fortawesome/fontawesome-free-solid";
import { getCookies } from "../../hooks/useCookies";
import { TableContext } from "../../contexts/tableContext";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import styles from "./viewCafe.module.scss";
import { DateFormatter } from "../../utilityFunctions/utilsFunctions";
import envValues from "../../enviornment";
import { Entry } from "../../redux/entrySlice";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import TextInput from "../../components/TextField/TextField";
import SelectBox from "../../components/SelectBox/SelectBox";
import CustomTable from "../../components/CustomTable/CustomTable";
import { REACT_APP_API_FETCH_MENUS } from "../../redux/apiConstants";
import FindSimilarCafesModal from "../mergerequests/findSimilarCafesModal";
import SuggestMergeModal from "../mergerequests/suggestMergeModal";
import DirectMergeModal from "../mergerequests/directMergeModal";
import StripeOverrideModal from "./StripeOverrideModal";
import CafeTransactionReportModal from "./CafeTransactionReportModal";
import VendorDocumentsSection from "./VendorDocumentsSection";
import Loader from '../../components/Loader/Loader';

function SuspendCafeModal({ show, handleClose, cafeId }) {
  const [submiting, setSubmitting] = useState(false);

  const periods = [
    {
      value: "1week",
      label: "1 Week",
    },
    {
      value: "1month",
      label: "1 Month",
    },
    {
      value: "6month",
      label: "6 Month",
    },
  ];

  console.log("cafe Id ", cafeId);

  const { errormsgStyle, setSuspend } = useContext(TableContext);
  const [error, setError] = useState(null);

  const dispatch = useDispatch();

  const {
    control,
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  function onSubmitdata(data) {
    console.log("datat", data);

    setSubmitting(true);
    const apiData = {
      suspendReason: data.reason,
      suspendPeriod: data.period,
    };
    data.actionUrl = `cafe/suspend-cafe/${cafeId}`;
    data.actionMethod = "post";
    data.apiData = apiData;
    dispatch(Entry(data)).then((resp) => {
      console.log("responsee-----", resp);
      setSubmitting(false);
      if (resp.payload.code === 200) {
        handleClose();
        toast.success("Cafe suspended successfully");
        setSuspend(true);
      } else if (resp.payload.code === 401 || resp.payload.code === 400) {
        setError(resp.payload.message);
        toast.success("Cafe suspended successfully");
      } else {
        setError(resp.payload.message);
      }
    });
  }

  const handleSuspend = () => {
    // Validate reason and period if needed
    // suspendCafe(reason, period);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Suspend Cafe</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit(onSubmitdata)}>
          <div>
            <TextInput
              className={styles.inputbox}
              classNamedark={styles.inputbox1}
              labelstyle={styles.formlabel}
              label="Reason"
              fieldName="reason"
              placeHolder="Enter reason"
              register={register}
              errors={errors}
              isRequired
              mandatory
            />
          </div>
          <div>
            <SelectBox
              className={styles.inputbox}
              classNamedark={styles.inputbox1}
              name="period"
              label="Period"
              labelstyle={styles.formlabel}
              control={control}
              register={register}
              values={periods}
              errors={errors}
              placeholder="Select Period"
              mandatory
              isRequired
            />
          </div>
          <Button color="primary" type="submit">
            Suspend
          </Button>{" "}
          <Button color="secondary" onClick={handleClose}>
            Cancel
          </Button>
          {error && (
            <h6 className={styles[errormsgStyle]} style={{ float: "right" }}>
              {error}
            </h6>
          )}
        </form>
      </Modal.Body>
    </Modal>
  );
}

function ViewCafe() {
  const { dashboardStyle } = useContext(TableContext);
  const { setDashboardHeader } = useContext(TableContext);
  const { bodyStyle } = useContext(TableContext);
  const { formthemeStyle } = useContext(TableContext);
  const { viewformStyle, suspend, setSuspend } = useContext(TableContext);
  const dispatch = useDispatch();
  const params = useParams();
  let cafeId;
  const token = `Bearer ${getCookies("Token")}`;
  const [loading, setLoading] = useState(true);
  const [details, setDetails] = useState([]);
  const dateFormat = getCookies("dateFormat");
  const [canDelete, setCanDelete] = useState(true);
  const [cafeList, setCafesList] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showRejectForm, setShowRejectForm] = useState(false);
  
  // Merge-related state
  const [showSimilarCafes, setShowSimilarCafes] = useState(false);
  const [showSuggestMerge, setShowSuggestMerge] = useState(false);
  const [showDirectMerge, setShowDirectMerge] = useState(false);
  const [pendingMergeRequest, setPendingMergeRequest] = useState(null);
  
  // Form handling for rejection
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  
  // Stripe Override state
  const [showStripeOverride, setShowStripeOverride] = useState(false);
  const [showTransactionReportModal, setShowTransactionReportModal] =
    useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };
  
  const handleCloseSimilarCafes = () => {
    setShowSimilarCafes(false);
  };
  
  const handleCloseSuggestMerge = () => {
    setShowSuggestMerge(false);
  };
  
  const handleCloseDirectMerge = () => {
    setShowDirectMerge(false);
  };
  
  const handleSelectSimilarCafe = (cafe) => {
    // When a similar cafe is selected, open suggest merge modal
    setShowSimilarCafes(false);
    setShowSuggestMerge(true);
  };
  
  const checkMergeStatus = async () => {
    try {
      const response = await axios.get(
        `${envValues.REACT_APP_API_ENDPOINT}/cafe/merge-requests?`,
        { 
          headers: { Authorization: token },
          params: {
            sourceCafe: params.cafeId,
            status: 'Pending,SuggestionPending,VendorAccepted'
          }
        }
      );
      if (response.data.success && response.data.data.result.results.length > 0) {
        setPendingMergeRequest(response.data.data.result.results[0]);
      }
    } catch (error) {
      console.error('Error checking merge status:', error);
    }
  };

  let statusCode;
  const getUserDetails = async () => {
    setLoading(true);
    axios
      .get(`${envValues.REACT_APP_API_ENDPOINT}/cafe/${cafeId}`, {
        method: "GET",
        headers: { Authorization: token },
      })
      .then((resp) => {
        statusCode = resp.status;
        return resp.data;
      })
      .then((res) => {
        if (statusCode === 200) {
          console.log("res.data.user", res.data.cafe);
          setDetails(res.data.cafe);
          setSuspend(res.data.cafe?.isSuspended);
          setLoading(false);
        } else {
          setLoading(false);
        }
      })
      .catch((err) => {
        setLoading(false);
        return err;
      });
  };
  
  const handleReviewDocument = (cafeId, documentType) => {
    confirmAlert({
      title: "Confirm Review",
      message: `Mark this ${documentType === 'healthPermit' ? 'Health Permit' : 'Insurance'} document as reviewed?`,
      buttons: [
        {
          label: "Yes, Mark as Reviewed",
          onClick: () => {
            const data = {
              actionUrl: `cafe/${cafeId}/review-document`,
              actionMethod: "post",
              apiData: { documentType },
            };
            dispatch(Entry(data)).then((resp) => {
              if (resp.payload.code === 200) {
                toast.success("Document marked as reviewed!");
                getUserDetails(); // Refresh cafe details
              } else {
                toast.error(resp.payload.message || "Failed to review document");
              }
            });
          },
        },
        {
          label: "Cancel",
          onClick: () => {},
        },
      ],
    });
  };
  
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    cafeId = params.cafeId;
    getUserDetails();
    checkMergeStatus();
    setDashboardHeader("Cafe Details");
  }, []);

  const handleDelete = (id) => {
    confirmAlert({
      title: canDelete ? "" : "Oops!!",
      message: "Are you sure you want to delete?",
      buttons: canDelete
        ? [
            {
              label: "Yes",
              onClick: () => {
                const actionData = {};
                actionData.actionUrl = `cafe/${id}`;
                actionData.actionMethod = "delete";
                dispatch(Entry(actionData)).then(() => {
                  navigate(-1);
                  toast.success("Cafe deleted successfully");
                });
              },
            },
            {
              label: "No",
              // onClick: () => alert("Click No")
            },
          ]
        : [
            {
              label: "Ok",
              // onClick: () => alert("Click No")
            },
          ],
    });
  };

  const removeSuspension = (id) => {
    confirmAlert({
      title: canDelete ? "" : "Oops!!",
      message: "Are you sure you want to remove suspension?",
      buttons: canDelete
        ? [
            {
              label: "Yes",
              onClick: () => {
                const actionData = {};
                actionData.actionUrl = `cafe/un-suspend-cafe/${id}`;
                actionData.actionMethod = "post";
                dispatch(Entry(actionData)).then(() => {
                  // navigate(-1);
                  setSuspend(false);
                  toast.success("Cafe unsuspended successfully");
                });
              },
            },
            {
              label: "No",
              // onClick: () => alert("Click No")
            },
          ]
        : [
            {
              label: "Ok",
              // onClick: () => alert("Click No")
            },
          ],
    });
  };

  const goToMenu = async () => {
    console.log("params.cafeId", params.cafeId);
    navigate(`/menu/${params.cafeId}`);
  };

  const handleReject = async (formData) => {
    const actionData = {
      actionUrl: `cafe/reject-cafe/${params.cafeId}`,
      actionMethod: "post",
      apiData: {
        notes: formData.rejectionNotes,
      },
    };
    
    dispatch(Entry(actionData))
      .then(() => {
        navigate(-1);
        setSuspend(false);
        setShowRejectForm(false);
        reset();
        toast.success("Cafe request rejected successfully");
      })
      .catch((err) => {
        toast.error("Error rejecting cafe request");
        console.error("Error: ", err);
      });
  };

  const handleApprove = async (id) => {
    // Check if application is rejected
    if (details?.applicationStatus && details.applicationStatus === "Rejected") {
      confirmAlert({
        title: "Application Rejected",
        message: "This café's application has been rejected. The vendor must resubmit their application with the required updates before it can be approved.",
        buttons: [
          {
            label: "View Application Details",
            onClick: () => {
              navigate(`/vendorapplications/viewdetails/${id}`);
            },
          },
          {
            label: "Close",
          },
        ],
      });
      return;
    }

    // If this cafe has an applicationStatus, show dialog to redirect to vendor applications
    if (details?.applicationStatus && (details.applicationStatus === "Submitted" || details.applicationStatus === "In Review")) {
      confirmAlert({
        title: "Review Application Documents",
        message: "Please review and approve all application documents first from the Vendor Applications section.",
        buttons: [
          {
            label: "Go to Application Details",
            onClick: () => {
              navigate(`/vendorapplications/viewdetails/${id}`);
            },
          },
          {
            label: "Cancel",
          },
        ],
      });
      return;
    }

    confirmAlert({
      title: canDelete ? "" : "Oops!!",
      message: "Are you sure you want to approve the cafe request?",
      buttons: canDelete
        ? [
            {
              label: "Yes",
              onClick: () => {
                const actionData = {};
                actionData.actionUrl = `cafe/approve-cafe/${id}`;
                actionData.actionMethod = "post";
                dispatch(Entry(actionData)).then(() => {
                  navigate(-1);
                  setSuspend(false);
                  toast.success("Cafe request approved successfully");
                });
              },
            },
            {
              label: "No",
              // onClick: () => alert("Click No")
            },
          ]
        : [
            {
              label: "Ok",
              // onClick: () => alert("Click No")
            },
          ],
    });
  };
  return (
    <div className={styles[bodyStyle]}>
      <div
        className={styles[dashboardStyle]}
        // style={{ height: "100vh" }}
        id={styles.dashboardcont2}
      >
        <div className={styles[formthemeStyle]} id={styles.addform}>
          {loading ? (
            <Loader centered />
          ) : (
            <Container fluid>
              <FontAwesomeIcon
                icon={faArrowLeft}
                value="Back"
                onClick={() => {
                  navigate(-1);
                }}
                className={styles.arrowback}
              />
              <Row>
                <Col lg={8}>
                  <div className={styles.profilepicdiv}>
                    {details.image ? (
                      <Image
                        src={details.image}
                        alt="logo"
                        className={styles.profilepic}
                      />
                    ) : (
                      <div>{details.name}</div>
                    )}
                  </div>
                </Col>
                {/* <Col lg={4}>
                  <div className={styles.profilepicdiv}>
                    <Button
                      onClick={() => {
                        goToMenu();
                      }}
                    >
                      Go to menu page
                    </Button>
                  </div>
                </Col> */}
              </Row>
              <Row className="mt-3">
                <Col lg={12} md={12} sm={12}>
                  <div className={styles.detaildiv}>
                    <Row>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Name</span>
                          <p className={styles.empname}>{details.name}</p>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>
                            Location (For GPS)
                          </span>
                          <p className={styles.empname}>
                            {details.location_name ?? "NA"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={8} md={12} sm={12}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Address</span>
                          <p className={styles.empname}>
                            {details?.address ?? "NA"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <div
                          className={`${styles[viewformStyle]} ${styles.workingHoursBlock}`}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Working Hours (24-hour format)</span>
                          {details?.timings && details.timings.length > 0 ? (
                            <div className={styles.workingHoursGrid}>
                            {details.timings.map((timing, index) => (
                              <div key={index} className={styles.timingContainer}>
                                <p className={styles.dayOfWeek}>
                                  {timing.dayOfWeek}:
                                </p>
                                {timing.periods && timing.periods.length > 0 ? (
                                  timing.periods.map((period, periodIndex) => (
                                    <div key={periodIndex} style={{ marginBottom: "4px" }}>
                                      {period.startLocalTime === "" || period.endLocalTime === "" ? (
                                        <p style={{ fontSize: "0.9rem", color: "#888", marginBottom: 0 }}>
                                          Period {periodIndex + 1}: NA
                                        </p>
                                      ) : (
                                        <p style={{ fontSize: "0.9rem", marginBottom: 0 }}>
                                          <span style={{ color: "#666" }}>Period {periodIndex + 1}: </span>
                                          <span className={styles.time}>
                                            {period.startLocalTime}
                                          </span>
                                          <span className={styles.time}> - </span>
                                          <span className={styles.time}>
                                            {period.endLocalTime}
                                          </span>
                                          {period.isNextDay && (
                                            <span style={{ fontSize: "0.75rem", color: "#ff6b6b", marginLeft: "6px" }}>
                                              (next day)
                                            </span>
                                          )}
                                        </p>
                                      )}
                                    </div>
                                  ))
                                ) : (
                                  // Fallback for old format with startTime/endTime
                                  timing.startTime && timing.endTime ? (
                                    <div>
                                      <p style={{ fontSize: "0.9rem", marginBottom: 0 }}>
                                        <span className={styles.time}>
                                          {timing.startTime}
                                        </span>
                                        <span className={styles.time}> - </span>
                                        <span className={styles.time}>
                                          {timing.endTime}
                                        </span>
                                      </p>
                                    </div>
                                  ) : (
                                    <p style={{ fontSize: "0.9rem", color: "#888", marginBottom: 0 }}>NA</p>
                                  )
                                )}
                              </div>
                            ))}
                            </div>
                          ) : (
                            <p className={styles.empname}>NA</p>
                          )}
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Name of Vendor</span>
                          <p className={styles.empname}>
                            {details?.vendor?.name ?? "NA"}
                          </p>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>Email</span>
                          <p className={styles.empname}>
                            {details?.vendor?.email ?? "NA"}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>
                            Total Orders Completed
                          </span>
                          <p className={styles.empname}>
                            {details.totalOrders ?? 0}
                          </p>
                        </div>
                      </Col>
                      <Col lg={4}>
                        <div
                          className={styles[viewformStyle]}
                          id={styles.empdiv}
                        >
                          <span className={styles.title}>
                            Social Media Links
                          </span>
                          <p className={styles.empname}>
                            {details.facebook ? (
                              <a
                                href={details.facebook}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Facebook
                              </a>
                            ) : null}
                            {details.facebook && details.instagram
                              ? " / "
                              : null}
                            {details.instagram ? (
                              <a
                                href={details.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                Instagram
                              </a>
                            ) : null}
                            {!details.facebook && !details.instagram
                              ? "NA"
                              : null}
                          </p>
                        </div>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col lg={12}>
                        <div className={styles.actionButtonsRow}>
                          <Button
                            className={`${styles.title} btn-success`}
                            onClick={() => {
                              handleApprove(details?._id);
                            }}
                          >
                            Approve Cafe
                          </Button>
                          <Button
                            className={`${styles.title} btn-danger`}
                            onClick={() => setShowRejectForm(!showRejectForm)}
                          >
                            {showRejectForm ? "Cancel Rejection" : "Reject Cafe"}
                          </Button>
                          <Button
                            className={`${styles.title} btn-warning`}
                            onClick={() => setShowStripeOverride(true)}
                          >
                            <i className="fa fa-stripe me-2" aria-hidden="true"></i>
                            Stripe Override
                          </Button>
                          {suspend ? (
                            <Button
                              className={styles.title}
                              onClick={() => removeSuspension(details?._id)}
                            >
                              Remove Suspension
                            </Button>
                          ) : (
                            <Button
                              className={`${styles.title} btn-secondary`}
                              onClick={() => setShowModal(true)}
                            >
                              Suspend Cafe
                            </Button>
                          )}
                          <SuspendCafeModal
                            show={showModal}
                            handleClose={handleCloseModal}
                            cafeId={details?._id}
                          />
                          <Button
                            className={`${styles.title} btn-danger`}
                            onClick={() => {
                              handleDelete(details?._id);
                            }}
                          >
                            Delete Cafe
                          </Button>
                        </div>
                      </Col>
                    </Row>
                    {details?.cafeStatus === "Pending" && <Row></Row>}
                    {!details?.isClaimed && !details.isClaimed && (
                      <Row>
                        <Col lg={4}>
                          <div
                            // className={styles[viewformStyle]}
                            id={styles.empdiv}
                          >
                            <Button
                              disabled={details?.claimRequests?.length === 0}
                              onClick={() =>
                                navigate(`/claim-requests/${params.cafeId}`)
                              }
                            >
                              Claim Requests:{" "}
                              {details?.claimRequests?.length || 0}
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    )}

                    {showRejectForm && (
                      <Row className="mt-4">
                        <Col lg={8}>
                          <div className="p-4 border rounded bg-light">
                            <h5 className="mb-3">Reject Cafe Application</h5>
                            <form onSubmit={handleSubmit(handleReject)}>
                              <div className="mb-3">
                                <label className="form-label">
                                  Rejection Notes <span className="text-danger">*</span>
                                </label>
                                <textarea
                                  className={`form-control ${errors.rejectionNotes ? 'is-invalid' : ''}`}
                                  rows={4}
                                  placeholder="Please provide detailed feedback for the vendor..."
                                  {...register("rejectionNotes", {
                                    required: "Rejection notes are required",
                                    minLength: {
                                      value: 10,
                                      message: "Please provide at least 10 characters of feedback",
                                    },
                                  })}
                                />
                                {errors.rejectionNotes && (
                                  <div className="invalid-feedback">
                                    {errors.rejectionNotes?.message}
                                  </div>
                                )}
                              </div>
                              <Button type="submit" variant="danger" className="me-2">
                                Confirm Rejection
                              </Button>
                              <Button
                                variant="secondary"
                                onClick={() => {
                                  setShowRejectForm(false);
                                  reset();
                                }}
                              >
                                Cancel
                              </Button>
                            </form>
                          </div>
                        </Col>
                      </Row>
                    )}
                    
                    <VendorDocumentsSection
                      cafe={details}
                      dateFormat={dateFormat}
                      canReviewDocuments
                      onReviewDocument={(documentType) =>
                        handleReviewDocument(details._id, documentType)
                      }
                    />
                    
                    <Row className="mt-4">
                      <Col lg={12}>
                        <hr style={{ margin: "20px 0", borderColor: "#e0e0e0" }} />
                        <h5 style={{ color: "#39979d", marginBottom: "15px" }}>
                          <i className="fa fa-file-excel me-2" aria-hidden="true" />
                          Transaction Reports
                        </h5>
                        <p style={{ color: "#6c757d", marginBottom: "12px" }}>
                          Download the same Detailed or Summary Excel report this
                          cafe receives in Reports.
                        </p>
                        <Button
                          className={styles.title}
                          onClick={() => setShowTransactionReportModal(true)}
                        >
                          Export Transaction Report
                        </Button>
                      </Col>
                    </Row>

                    {/* Merge Actions Section */}
                    <Row className="mt-4">
                      <Col lg={12}>
                        <hr style={{ margin: '20px 0', borderColor: '#e0e0e0' }} />
                        <h5 style={{ color: '#39979d', marginBottom: '15px' }}>
                          <FontAwesomeIcon icon={faCodeBranch} className="me-2" />
                          Cafe Merge Actions
                        </h5>
                        
                        {/* Merged Cafe Warning */}
                        {details?.mergedInto && (
                          <Alert variant="warning" className="mb-3">
                            <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                            <strong>This cafe has been merged</strong> into another cafe.
                            {' '}
                            <Button 
                              variant="link" 
                              onClick={() => navigate(`/cafe/viewdetails/${details.mergedInto}`)}
                              style={{ padding: 0, verticalAlign: 'baseline' }}
                            >
                              View merged cafe
                            </Button>
                          </Alert>
                        )}
                        
                        {/* Pending Merge Request Badge */}
                        {pendingMergeRequest && !details?.mergedInto && (
                          <Alert variant="info" className="mb-3">
                            <Badge bg="info" className="me-2">Pending Merge Request</Badge>
                            This cafe has a pending merge request.
                            {' '}
                            <Button 
                              variant="link" 
                              onClick={() => navigate(`/mergerequests/${pendingMergeRequest._id}`)}
                              style={{ padding: 0, verticalAlign: 'baseline' }}
                            >
                              View request
                            </Button>
                          </Alert>
                        )}
                        
                        {/* Merge Action Buttons */}
                        {!details?.mergedInto && (
                          <Row>
                            <Col lg={3} md={6} sm={12} className="mb-2">
                              <Button
                                variant="outline-primary"
                                className="w-100"
                                onClick={() => setShowSimilarCafes(true)}
                              >
                                <FontAwesomeIcon icon={faSearch} className="me-2" />
                                Find Similar Cafes
                              </Button>
                            </Col>
                            <Col lg={3} md={6} sm={12} className="mb-2">
                              <Button
                                variant="outline-success"
                                className="w-100"
                                onClick={() => setShowSuggestMerge(true)}
                              >
                                <FontAwesomeIcon icon={faCodeBranch} className="me-2" />
                                Suggest Merge
                              </Button>
                            </Col>
                            <Col lg={3} md={6} sm={12} className="mb-2">
                              <Button
                                variant="outline-danger"
                                className="w-100"
                                onClick={() => setShowDirectMerge(true)}
                              >
                                <FontAwesomeIcon icon={faCodeBranch} className="me-2" />
                                Direct Merge
                              </Button>
                            </Col>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
              {cafeList.length > 0 && (
                <Row>
                  <Col lg={12}>
                    <h5>Cafes</h5>
                    <ol>
                      {cafeList?.map((cafe, index) => (
                        <li key={cafe.id}>
                          {/* <span>{index + 1}. </span> */}
                          <span>{cafe.name}</span>
                          <span> {cafe?.location_name}</span>
                        </li>
                      ))}
                    </ol>
                  </Col>
                </Row>
              )}
            </Container>
          )}
        </div>
      </div>
      <Row>
        <Col lg={12}>
          <CustomTable
            urlParam={`${REACT_APP_API_FETCH_MENUS}/${params.cafeId}?`}
            // viewPopUp
            section="Menus"
            toggleButton={{ show: true, field: "active" }}
            deleteCondition={{
              checkCondition: false,
              apiUrl: "www.google.com",
            }}
          />
        </Col>
      </Row>
      
      {/* Merge Modals */}
      <FindSimilarCafesModal
        show={showSimilarCafes}
        handleClose={handleCloseSimilarCafes}
        cafeId={params.cafeId}
        onSelectCafe={handleSelectSimilarCafe}
      />
      
      <SuggestMergeModal
        show={showSuggestMerge}
        handleClose={handleCloseSuggestMerge}
        sourceCafeId={params.cafeId}
        onSuccess={() => {
          toast.success('Merge suggestion sent successfully');
          checkMergeStatus();
        }}
      />
      
      <DirectMergeModal
        show={showDirectMerge}
        handleClose={handleCloseDirectMerge}
        onSuccess={() => {
          toast.success('Cafes merged successfully');
          getUserDetails();
        }}
      />
      
      <CafeTransactionReportModal
        show={showTransactionReportModal}
        handleClose={() => setShowTransactionReportModal(false)}
        cafeId={params.cafeId || details?._id}
        cafeName={details?.name}
      />

      <StripeOverrideModal
        show={showStripeOverride}
        handleClose={() => setShowStripeOverride(false)}
        cafeId={params.cafeId}
        cafeData={details}
        onSuccess={() => {
          getUserDetails();
        }}
      />
    </div>
  );
}

export default ViewCafe;
